import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import history from '../utils/history';

import authReducer from './authReducer'
import utilReducer from './utilReducer'
import producersReducer from './producersReducer'
import materialsReducer from './materialsReducer'
import companySettingsReducer from './companySettingsReducer'
import customersReducer from "./customersReducer";
import customerSettingsReducer from "./customerSettingsReducer";
import adminReducer from "./adminReducer";
import customerRelationsReducer from "./customerRelationsReducer";
import bulkOrderReducer from "./bulkOrderReducer"
import orderReducer from "./orderReducer";
import bendingReducer from "./bendingReducer";
import simpleMachiningReducer from "./simpleMachiningReducer";
import surfaceCoatingReducer from "./surfaceCoatingReducer";
import cuttingMachinesReducer from "./cuttingMachinesReducer";
import ordersReducer from "./ordersReducer";
import corporateCustomersReducer from "./corporateCustomersReducer";
import subAdminReducer from "./subAdminReducer";
import nestingReducer from "./nestingReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  util: utilReducer,
  producers: producersReducer,
  subAdmins: subAdminReducer,
  customers: customersReducer,
  corporateCustomers: corporateCustomersReducer,
  materials: materialsReducer,
  bending: bendingReducer,
  simpleMachining: simpleMachiningReducer,
  surfaceCoating: surfaceCoatingReducer,
  cuttingMachines: cuttingMachinesReducer,
  router: connectRouter(history),
  companySettings: companySettingsReducer,
  customerSettings: customerSettingsReducer,
  admin: adminReducer,
  customerRelations: customerRelationsReducer,
  bulkOrder: bulkOrderReducer,
  order: orderReducer,
  orders: ordersReducer,
  nesting: nestingReducer
})

export default rootReducer
